import { FULFILLMENT_LABELS, STATUS_LABELS, type FulfillmentType, type OrderStatus } from '@pizza-roma/shared';
import { getLang, getLocale } from '../i18n';

// Formatting follows the current language (en-CA or fr-CA).
export const money = (cents: number, currency = 'CAD') =>
  new Intl.NumberFormat(getLocale(), { style: 'currency', currency }).format((cents ?? 0) / 100);

export const time = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleTimeString(getLocale(), { hour: '2-digit', minute: '2-digit' }) : '';

export const dateTime = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleString(getLocale(), { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '';

export const minutesSince = (iso: string, now = Date.now()) => Math.max(0, Math.floor((now - new Date(iso).getTime()) / 60000));

export const statusLabel = (s: OrderStatus) => STATUS_LABELS[getLang()][s] ?? s;
export const typeLabel = (t: FulfillmentType) => FULFILLMENT_LABELS[getLang()][t] ?? t;

export function statusClass(s: OrderStatus): string {
  switch (s) {
    case 'PAID':
      return 'b-new';
    case 'ACCEPTED':
      return 'b-accepted';
    case 'PREPARING':
      return 'b-preparing';
    case 'READY':
    case 'ASSIGNED':
      return 'b-ready';
    case 'PICKED_UP':
    case 'OUT_FOR_DELIVERY':
      return 'b-route';
    case 'DELIVERED':
      return 'b-done';
    case 'PENDING_PAYMENT':
      return 'b-pending';
    default:
      return 'b-cancel';
  }
}

export const initials = (name?: string | null) =>
  (name ?? '?')
    .split(/\s+/)
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

export function addressLine(a: Record<string, unknown> | null | undefined) {
  if (!a) return '';
  return [a.line1, a.line2, a.city].filter(Boolean).join(', ');
}
